export const environment = {
    production: true, // ✅ true para usar URL completa
    useMockAuth: true, // 🔧 true para usar login MOCK en demo (sin backend real)
    apiUrl: 'https://prdbck.job360.cl',
    aiServiceUrl: 'https://109.205.181.194', // ✅ HTTPS con IP (temporal hasta DNS)
    // aiServiceUrl: 'https://api-job360.helicexworkweb.es', // ✅ Usar cuando DNS se propague
    endpoints: {
        register: '/admin/candidate',
        login: '/auth/login',
        swagger: '/api-docs/swagger.json',
        aiGenerate: '/api/gemini/generar-descripcion'
    }
};
